// import axios from "axios";

// // Create an Axios instance
// const axiosInstance = axios.create({
//   baseURL: "https://api-uat.shopdiy.in/", //uat
//   // baseURL: "https://uat-api.shopdiy.in", //live
  // baseURL: "http://192.168.0.160:5678/",
//   // baseURL: "http://10.30.188.27:5678",
//   // timeout: 5000, // Set the timeout for requests (optional)
// });

// // Add a request interceptor to attach the token from localStorage
// axiosInstance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token"); // Retrieve the token from localStorage
//   if (token) {
//     config.headers["Authorization"] = `Token ${token}`; // Add the token to the request headers
//   }

//   // config.headers["domain"] = "bgbonline.in";
//   // config.headers["domain"] = "192.168.0.160";
//   // config.headers["domain"] = "10.30.188.27";
//   config.headers["domain"] = window.location.hostname.replace(
//     /\bdashboard.\b/g,
//     ""
//   );
//   return config;
// });

// export default axiosInstance;
import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://api-uat.shopdiy.in/", //uat
  // baseURL: "https://uat-api.shopdiy.in", //production
  // baseURL: "http://192.168.1.10:1234", //local
  // baseURL: "http://192.168.1.18:1234/", //local

});

//uat: 15.206.37.249

// live: 15.206.156.98

// Platform detection (simple inline)
const getPlatformDetails = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  const isMobile =
    /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(userAgent);

  let platform = "web";
  let deviceName = "Desktop Browser";
  let appVersion = "web-1.0.0";

  if (isMobile) {
    platform = "mobile_web";
    appVersion = "web-mobile-1.0";

    if (userAgent.includes("chrome")) {
      deviceName = "Mobile Chrome Browser";
    } else if (userAgent.includes("safari")) {
      deviceName = "Mobile Safari";
    } else {
      deviceName = "Mobile Browser";
    }
  } else {
    if (userAgent.includes("chrome")) {
      deviceName = "Chrome Browser";
    } else if (userAgent.includes("firefox")) {
      deviceName = "Firefox Browser";
    } else if (userAgent.includes("safari")) {
      deviceName = "Safari Browser";
    }
  }

  const deviceId = `${platform}-${Math.random().toString(36).substring(2, 10)}`;

  return { platform, deviceName, appVersion, deviceId };
};

// Add a request interceptor
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  // config.headers["domain"] = "uat.bgbonline.in";

 
  // ✅ added headers (same style, no extra logic)
  const { platform, deviceName, appVersion, deviceId } =
    getPlatformDetails();

  config.headers["Platform"] = platform;
  config.headers["Device-Id"] = deviceId;
  config.headers["Device-Name"] = deviceName;
  config.headers["App-Version"] = appVersion;

  // Uncomment the below when deploying to dev or prod

  config.headers["domain"] = window.location.hostname.replace(/^dashboard[-.]/, "") || window.location.hostname;
 
  // Uncomment the above when deploying to dev or prod


  // config.headers["domain"] = "192.168.1.10"; //local-testing
  // config.headers["domain"] = "bgbonline.in"; //prod-testing
// config.headers["domain"] = "uat.bgbonline.in"; //dev-testing
  return config;
});

export default axiosInstance;